let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("i79gN")).then(() => parcelRequire('drZ61'));